import { forwardRef } from 'react';
import { DropContentStyled } from './drop-content.styled';
import { IDropContentProps } from './drop-content.types';

export const DropContent = forwardRef<HTMLDivElement, IDropContentProps>(
  ({ children }, ref) => {
    return <DropContentStyled ref={ref}>{children}</DropContentStyled>;
  },
);
